import {
  Edit,
} from "react-admin";
import { useAuth } from "../../../hooks/useAuth";
import { CarrierTitle } from "./index";
import CarrierFields from "./Fields";

export const CarrierEdit = () => {
  const { user, isAgencyAdmin, isFullAdmin } = useAuth();

  return (
    <Edit title={<CarrierTitle />}>
      <CarrierFields
        user={user}
        isAgencyAdmin={isAgencyAdmin}
        isFullAdmin={isFullAdmin}
      />
    </Edit>
  );
};
export default CarrierEdit;
